import { useNavigate } from "react-router-dom";
import InstaToolFeatureList from "./InstaToolFeatureList";
import { useInfluencerCheckout } from "../../influencer-subscription/context/InfluencerCheckoutContext";
import { useSelector } from "react-redux";
import { selectInfluencerPlanType } from "../../../Redux/userSlice";

const InstaToolPricingCard = ({ plan }) => {
  const navigate = useNavigate();
  const { openCheckout } = useInfluencerCheckout();
  const currentPlanType = useSelector(selectInfluencerPlanType);
  const isCurrentPlan = currentPlanType === plan.planType;
  const isDarkTheme = plan.theme === "dark";
  const isPurchasable = plan.planType !== "free";

  const formattedPrice =
    plan.price > 0
      ? `${plan.currencySymbol}${plan.price}${
          plan.billingCycle === "monthly" ? "/month" : ""
        }`
      : "Free";

  const handlePayNow = () => {
    if (!isPurchasable || isCurrentPlan) return;
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/influencer/login?redirectTo=/insta-tools/pricing");
      return;
    }
    openCheckout(plan);
  };

  const isDisabled = plan.disabled || !isPurchasable || isCurrentPlan;
  const ctaLabel = isCurrentPlan ? "Your Current Plan" : plan.cta;

  return (
    <article
      className={`w-full max-w-md border border-black rounded-lg py-5 px-[25px] flex flex-col justify-between transition ${
        isDarkTheme ? "bg-black text-white" : "bg-white text-black"
      }`}
      aria-label={`${plan.name} pricing plan`}
    >
      <div>
        {plan.badge && (
          <span
            className={`inline-block text-xs font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full mb-3 ${
              isDarkTheme
                ? "bg-white/10 text-white"
                : "bg-black text-white"
            }`}
          >
            {plan.badge}
          </span>
        )}

        <p className="text-sm font-semibold">{plan.name}</p>
        <h2 className="text-3xl font-bold mt-2">{formattedPrice}</h2>

        {plan.description && (
          <p
            className={`mt-3 text-xs md:text-sm leading-relaxed ${
              isDarkTheme ? "text-white/70" : "text-black/60"
            }`}
          >
            {plan.description}
          </p>
        )}

        <InstaToolFeatureList features={plan.features} theme={plan.theme} />
      </div>

      <div className="mt-8">
        <button
          type="button"
          disabled={isDisabled}
          onClick={handlePayNow}
          className={`w-full py-3 rounded-lg font-semibold transition ${
            isDisabled
              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
              : isDarkTheme
              ? "bg-white text-black hover:bg-gray-100"
              : "border border-black hover:bg-gray-50"
          }`}
        >
          {ctaLabel}
        </button>

        {isPurchasable && (
          <p className="text-xs text-center mt-3 opacity-70">
            Secure payment · Cancel anytime
          </p>
        )}
      </div>
    </article>
  );
};

export default InstaToolPricingCard;
